<template>
  <div class="widget-tip">
    <div>
      <CalicoChip :text="title" />
    </div>
    <div class="description-container">
      <div class="description-card">
        <div>
          <i class="bi bi-rocket-takeoff-fill contained-icon-medium-outlined" />
        </div>
        <div>
          <h3 class="title heading--xsmall">
            {{ firstDescriptionTitle }}
          </h3>
        </div>
        <div>
          <p class="body body--medium">
            {{ firstDescriptionBody }}
          </p>
        </div>
      </div>
      <div class="description-card">
        <i class="bi bi-people-fill contained-icon-medium-outlined" />
        <div>
          <h3 class="title heading--xsmall">
            {{ secondDescriptionTitle }}
          </h3>
        </div>
        <div>
          <p class="body body--medium">
            {{ secondDescriptionBody }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import CalicoChip from '@/components/calico/chip/index.vue';
  
  export default {
    name: "TipWidget",
    components: {
      CalicoChip
    },
    props: {
      title: {
        type: String,
        required: true
      },
      firstDescriptionTitle: {
        type: String,
        required: true
      },
      firstDescriptionBody: {
        type: String,
        required: true
      },
      secondDescriptionTitle: {
        type: String,
        required: true
      },
      secondDescriptionBody: {
        type: String,
        required: true
      }
    },
  };
  </script>
  
  <style scoped lang="scss">
  .widget-tip {
    @include stack-space($space-medium);
    justify-content: center;
    align-items: flex-start;
    
  .description-container {
    @include stack-space($space-medium);
  }
  
  .description-card {
    @include stack-space($space-small);
    width: 100%;
    max-width: 470px;
    align-items: start;
    padding: $space-medium;
    border-radius: $radius-small;
    border: 1px solid $color-neutral-light;
  }
  
  .icon {
    font-size: $icon-medium;
    color: $color-black;
  }
  
  .title {
    margin: 0;
  }
  
  .body {
    margin:0;
  }
}
  </style>